import { Button, Text, VSpacer } from '@/components/DesignSystem';
import { ApiPromotion } from '@api/interfaces';
import { Stack, useTheme } from '@mui/material';
import { SponsorType } from '@shared/enums';
import { getJsDateFromString } from '@shared/utilities';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PromotionCardProps {
  listItem?: boolean,
  onClickDetails: () => void,
  promotion: ApiPromotion,
  width?: string | number,
}

export const PromotionCard = ({
  listItem = false,
  onClickDetails,
  promotion,
  width = '252px',
}: PromotionCardProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const manufacturerName = promotion.manufacturer?.name ?? '';
  return (
    <Stack
      bgcolor={theme.palette.background.default}
      borderRadius="8px"
      boxShadow={listItem
        ? '0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)'
        : undefined
      }
      minHeight={listItem ? undefined : '302px'}
      minWidth="252px"
      p="16px"
      width={width}
    >
      <Stack flexGrow={listItem ? undefined : '1'}>
        {promotion.sponsorType === SponsorType.Manufacturer && (
          <>
            <Text category="overline">
              {manufacturerName} {t($ => $.products.promotionCard.label)}
            </Text>
            <VSpacer size="2" />
          </>
        )}
        <Text
          fontSize="24px"
          fontWeight={500}
          lineHeight={1.25}
          sx={{ hyphens: 'auto', wordBreak: 'break-word' }}
        >
          {promotion.name}
        </Text>
      </Stack>
      <VSpacer size="3" />
      <Stack
        alignItems={listItem ? 'flex-end' : 'center'}
        direction={listItem ? 'row-reverse' : 'column'}
        justifyContent={listItem ? 'space-between' : undefined}
      >
        <Button
          onClick={onClickDetails}
          sx={{
            bgcolor: theme.palette.grey[100],
            boxShadow: 'none',
            '&:hover': { bgcolor: theme.palette.grey[100] },
            color: theme.palette.text.primary,
          }}
          testID={`dashboard-promotion-${promotion.id}-button`}
        >
          {t($ => $.common.actions.details)}
        </Button>
        {!listItem && (
          <VSpacer size="4"/>
        )}
        <Text category="body-small">
          {t(
            $ => $.products.promotionCard.expires,
            { date: getJsDateFromString(promotion.endDate) },
          )}
        </Text>
      </Stack>
    </Stack>
  );
};
